import { useEffect, useState } from 'react'

import { Text, Caption } from '@/shared/components/typography'

interface ParkinglotPriceInfoViewProps {
  priceInfo: { key: string; value: string }[]
}

const initialInfoState: { key: string; value: string }[] = [
  { key: '초기 무료', value: '해당항목없음' },
  { key: '기본 요금', value: '해당항목없음' },
  { key: '추가 요금', value: '해당항목없음' }
]

const ParkinglotPriceInfoView = ({ priceInfo }: ParkinglotPriceInfoViewProps) => {
  const [info, setInfo] = useState(initialInfoState)

  useEffect(() => {
    if (priceInfo.length > 0) {
      setInfo((prev) =>
        prev.map((item) => ({
          ...item,
          value:
            priceInfo.find((info) => `${info.key.slice(0, 2)} ${info.key.slice(2)}` === item.key)?.value ??
            String(item.value)
        }))
      )
    } else {
      setInfo(initialInfoState)
    }
  }, [priceInfo])

  return (
    <div className="h-full w-full">
      <Text level="text3" weight="bold" color="text090">
        요금 정보
      </Text>
      <div className="mt-[16px] flex flex-col items-center justify-center gap-[8px]">
        {info.map(({ key, value }) => (
          <div key={key} className="flex w-full items-center justify-between">
            <Caption level="caption1" color="text070" weight="regular">
              {key}
            </Caption>
            <Caption level="caption1" color={value === '해당항목없음' ? 'text050' : 'text090'} weight="regular">
              {value === '해당항목없음' ? '정보없음' : value}
            </Caption>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ParkinglotPriceInfoView
